import { render } from "./ErrorState.vue?vue&type=template&id=a9912740"
import script from "./ErrorState.vue?vue&type=script&lang=js"
export * from "./ErrorState.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__